var Router = require("../lib/routerjs");
var kotemplates = require("../template/kotemplates");
var common = require("../utiles/common");
var routerUtils = require("../utiles/routerUtils");
var routeUtils = require("./routeUtils");

module.exports = {
  reloadPage: function (html) {
    kotemplates.registerCommons();
    $("body").html("<div id='main'>" + html + "</div>");
    ko.applyBindings({}, $("#main").get(0));
  },
  clear: function () {
    common.clear();
  },
  clearAll: function () {
    this.clear();
    $("body").removeData("user");
  },
  /**
   *  IE 6 不支持query, 不支持params
   *  参数只能自己想办法解析
   */
  initialRoutes: function () {
    var $this = this;
    var router = new Router();
    routeUtils.addRoute(router, $this);
    router
      .addRoute("#/", function (req, next) {
        $this.clearAll();
        routerUtils.ccbLogin(router);
      })
      .errors(404, function (err, href) {
        common.errorAlert("很抱歉，您要访问的页面不存在！");
      })
      .run(location.hash);
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/routes/index.js
// module id = 27
// module chunks = 0